export const storage = localStorage